/** @format */
import { ViewCustomerAddress } from '../ViewCustomerAddress'

export const CustomerMetadataAddress = ({ selectedCustomer }) => {
  return <ViewCustomerAddress customer={selectedCustomer} />
}
